import { InitOptions, ModuleType, ResourceLanguage, Services } from "i18next";
import { LxLocale } from "../../Types/LxLocale";
import { ResolverFunction } from "../LxI18N.model";

class LxI18NBackend {
  public static type: ModuleType = "backend";
  private resolvers: ResolverFunction[] = [];
  constructor(private services: Services) {}

  save(language: string, namespace: string, data: ResourceLanguage) {
    console.log("!! save:", language, namespace, data);
  }

  log(...args: any[]) {
    this.services.logger.log("LxI18NBackend:", args);
  }

  init(
    services: Services,
    backendOptions: object,
    i18nextOptions: InitOptions
  ): void {
    this.services = services;
    this.log(services, backendOptions, i18nextOptions);
    this.resolvers = (backendOptions as any).resolvers;
  }

  read(language: string, namespace: string, callback: any) {
    const translations: any = [];

    Promise.all(
      this.resolvers.map(async (resolver) => {
        const flatTranslations = await resolver(
          language as LxLocale,
          namespace
        );
        if (flatTranslations && flatTranslations.default) {
          translations.push(
            reconstructTranslations(namespace, flatTranslations.default)
          );
        }
      })
    )
      .then(() => {
        const mergedTranslations = merge(translations);
        // this.log(
        // `read language "${language}" and namespace ${namespace}: ${JSON.stringify(mergedTranslations)}`,
        // );
        callback(null, mergedTranslations);
      })
      .catch((e) => {
        console.error(
          `💥 Error while loading the translations for namespace "${namespace}" and locale "${language}":`,
          e
        );
        callback(e, null);
      });
  }
}

(LxI18NBackend as any).type = "backend";

export default LxI18NBackend;

//
// Helper
//

// Function that takes a namespace and a flat object of translations
// and returns a translation object for the given namespace.
function reconstructTranslations(
  namespace: string,
  flatTranslations: { [key: string]: string | null }
) {
  return Object.keys(flatTranslations)
    .filter((key) => flatTranslations[key] !== null)
    .map((key) => {
      // FlatTranslation keys are in the form of "namespace.key"
      const [namespace, shortKey] = key.split(".");
      const value = flatTranslations[key];
      return [namespace, shortKey, value];
    })
    .filter(([ns]) => ns === namespace)
    .reduce(
      (acc, [, shortKey, value]) => ({ [shortKey as string]: value, ...acc }),
      {}
    );
}

// Function that merges multiple translation objects into one.
function merge(objs: object[]) {
  return objs.reduce((acc, obj) => ({ ...acc, ...obj }), {});
}
